var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('el-container',[_c('el-header',[_c('Header')],1),_c('el-main',{staticClass:"mainwrap"},[_c('router-view'),_c('Footer')],1)],1),_c('el-backtop',{attrs:{"target":".mainwrap","bottom":80}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }